import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import {Property} from "../../property.model";

export class SalesProperty extends AbstractReport {

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

}

AccessorsMutatorsDecorator(
    'id',
    'name',
    'name_ar',
    'total',
)(SalesProperty);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/admin-report/sales-property.model.js